/** Couleurs des signalements, identiques sur la carte, dans les filtres et les graphiques. */
export const STATUS_COLORS = {
    OPEN: '#DC2626',
    IN_PROGRESS: '#EA580C',
    RESOLVED: '#16A34A',
    REJECTED: '#64748B',
};
export const PRIORITY_COLORS = {
    URGENT: '#DC2626',
    HIGH: '#EA580C',
    NORMAL: '#EAB308',
    LOW: '#16A34A',
};
/** Couleur d'une catégorie sans couleur dans le catalogue */
export const DEFAULT_CATEGORY_COLOR = '#6B7280';
//# sourceMappingURL=report-colors.js.map